<template>
    <div>
        <div v-if="puedeEditar()" class="col-12 lg:col-12 px-0">
            <Toolbar class="mb-2">
                <template #end>
                    <Button label="Nuevo" icon="pi pi-plus" class="p-button-success mr-2" @click="agregarUnidad" />
                </template>
            </Toolbar>
        </div>
        <DataTable :value="lstUnidades" dataKey="Id_unidad" scrollDirection="both" :filters="filters" :scrollable="true"
            scrollHeight="65vh" :paginator="false" :loading="loading">
            <template #header>
                <div class="table-header">
                    <h5> UNIDADES ASIGNADAS</h5>
                    <span>
                        Numero de registros {{ lstUnidades ? lstUnidades.length : 0 }}
                    </span>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                    </span>
                </div>
            </template>
            <template #empty> No se encontrarón registros.</template>
            <template #loading>Cargando datos. Espere por favor</template>
            <Column v-if="puedeEditar()" style="width:100px">
                <template #body="slotProps">
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-4" aria-label="Editar"
                        @click="editarUnidad(slotProps.data)" />
                </template>
            </Column>
            <Column field="Unidad" header="Unidad" sortable style="width:200px"></Column>
            <Column field="NombreCompletoAuxiliar" header="Auxiliar" sortable style="width:200px">
                <template #body="slotProps">
                    <div>
                        {{ slotProps.data.NombreCompletoAuxiliar }}
                        <small style="color: blue" class="small-text">{{ slotProps.data.Correo_instAuxiliar }}</small><br>
                        <small style="color: blue" class="small-text">{{ slotProps.data.TelefonoAuxiliar }}</small>
                    </div>
                </template>
            </Column>
            <Column field="NombreCompletoOficial" header="Oficial" sortable style="width:200px">
                <template #body="slotProps">
                    <div>
                        {{ slotProps.data.NombreCompletoOficial }}
                        <small style="color: blue" class="small-text">{{ slotProps.data.Correo_instOficial }}</small><br>
                        <small style="color: blue" class="small-text">{{ slotProps.data.TelefonoOficial }}</small>
                    </div>
                </template>
            </Column>
            <Column field="NombreCompletoCoordinador" header="Coordinador" sortable style="width:200px">
                <template #body="slotProps">
                    <div>
                        {{ slotProps.data.NombreCompletoCoordinador }}
                        <small style="color: blue" class="small-text">{{ slotProps.data.Correo_instCoordinador }}</small><br>
                        <small style="color: blue" class="small-text">{{ slotProps.data.TelefonoCoordinador }}</small>
                    </div>
                </template>
            </Column>
            <Column field="Amiba" header="Amiba" sortable style="width:100px">
                <template #body="{ data }">
                    <span>{{ getAmiba(data.Amiba) }}</span>
                </template>
            </Column>    
            <Column field="NombreUnidadCabecera" header="Cabecera" sortable style="width:200px"></Column>
            <Column field="UBI" header="UBI" sortable style="width:200px"></Column>
            <Column field="UI" header="UI" sortable style="width:200px"></Column>
            <Column field="Abreviacion" header="Abreviacion" sortable style="width:200px"></Column>
            <Column field="Descripcion_inventario" header="Descripcion Inventario" sortable style="width:200px"></Column>
            <Column field="Descripcion_site" header="Descripcion SITE" sortable style="width:200px"></Column>
            <Column field="Descripcion_admin" header="Descripcion ADMIN" sortable style="width:200px"></Column>
            <Column field="Descripcion_remedy" header="Descripcion REMEDY" sortable style="width:200px"></Column>
            <Column field="Direccion" header="Direccion" sortable style="width:200px"></Column>
            <Column field="Estado" header="Estado" sortable style="width:200px"></Column>
            <Column field="Municipio" header="Municipio" sortable style="width:200px"></Column>
            <Column field="CP" header="Codigo Postal" sortable style="width:200px"></Column>
            <Column field="Latitud" header="Latitud" sortable style="width:200px"></Column>
            <Column field="Longitud" header="Longitud" sortable style="width:200px"></Column>
        </DataTable>

        <Dialog :style="{ width: '550px' }" :visible="showDialog" :modal="true" class="p-fluid" :closable="false">
            <template #header>
                <h3>{{ modoEdicion }} Unidad</h3>
            </template>
            <div class="p-formgrid grid">
                <div class="p-field col-6">
                    <label for="Unidad">Unidad</label>
                    <InputText autocomplete="off" id="unidad" v-model.trim="objUnidades.Unidad" required="true" autofocus
                        :class="{ 'p-invalid': submitted && !objUnidades.Unidad }"  />
                    <small style="color: red;" class="p-invalid" v-if="submitted && !objUnidades.Unidad">La unidad es requerida.</small>
                </div>
                <div class="p-field col-6">
                    <label for="UBI">UBI</label>
                    <InputText autocomplete="off" id="ubi" v-model.trim="objUnidades.UBI" required="true" autofocus />
                </div>
                <div class="p-field col-6">
                    <label for="UI">UI</label>
                    <InputText autocomplete="off" id="ui" v-model.trim="objUnidades.UI" required="true" autofocus />
                </div>
                <div class="p-field col-6">
                    <label for="abreviacion">Abreviacion</label>
                    <InputText autocomplete="off" id="ui" v-model.trim="objUnidades.Abreviacion" required="true" autofocus />
                </div>
                <div class="p-field col">
                    <label for="descripcion_inventario">Descripcion inventario</label>
                    <InputText autocomplete="off" id="descripcion_unidad" v-model.trim="objUnidades.Descripcion_inventario"
                        required="true" autofocus />
 
                </div>
                <div class="p-field col">
                    <label for="Descripcion_site">Descripcion SITE</label>
                    <InputText autocomplete="off" id="descripcion_site" v-model.trim="objUnidades.Descripcion_site"
                        required="true" autofocus />

                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="p-field col">
                    <label for="Descripcion_admin">Descripcion ADMIN</label>
                    <InputText autocomplete="off" id="descripcion_admin" v-model.trim="objUnidades.Descripcion_admin"
                        required="true" autofocus  />
                </div>
                <div class="p-field col">
                    <label for="Descripcion_site">Descripcion REMEDY</label>
                    <InputText autocomplete="off" id="descripcion_site" v-model.trim="objUnidades.Descripcion_remedy"
                        required="true" autofocus />
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="p-field col">
                    <label for="Direccion">Direccion</label>
                    <InputText autocomplete="off" id="direccion" v-model.trim="objUnidades.Direccion" required="true" autofocus  />
                </div>
                <div class="p-field col">
                    <label for="Estado"> Estado</label>
                    <InputText autocomplete="off" id="estado" v-model.trim="objUnidades.Estado" required="true" autofocus/>
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="p-field col">
                    <label for="Latitud"> Latitud </label>
                    <InputText autocomplete="off" id="latitud" v-model.trim="objUnidades.Latitud" required="true" autofocus/>
                </div>
                <div class="p-field col">
                    <label for="Longitud"> Longitud </label>
                    <InputText autocomplete="off" id="longitud" v-model.trim="objUnidades.Longitud" required="true" autofocus />
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="p-field col">
                    <label for="Municipio"> Municipio</label>
                    <InputText autocomplete="off" id="municipio" v-model.trim="objUnidades.Municipio" required="true" autofocus/>
                </div>
                <div class="p-field col">
                    <label for="CP"> Codigo Postal </label>
                    <InputText autocomplete="off" id="cp" v-model.trim="objUnidades.CP" required="true" autofocus/>
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="p-field col-6">
                    <label for="amiba">Amiba</label>
                    <Dropdown id="amiba" v-model="objUnidades.Amiba" :options="amiba"
                      optionLabel="label" optionValue="value" placeholder="¿ Es una amiba ? " 
                      :class="{'p-invalid': submitted && objUnidades.Amiba === null}"/>
                      <small style="color: red;" class="p-invalid" v-if="submitted && objUnidades.Amiba === null">El campo Amiba es requerido.</small>
                </div>
                <div class="p-field col-6" v-if="objUnidades.Amiba">
                    <label for="Cabecera">Cabecera</label>
                    <Dropdown id="cabecera" v-model="objUnidades.Id_cabecera" :options="lstUnidades"
                      optionLabel="Unidad" optionValue="Id_unidad" placeholder="Seleccione la unidad" 
                      :class="{ 'p-invalid': submitted && !objUnidades.Id_cabecera }" :filter="true" />
                      <small style="color: red;" class="p-invalid" v-if="submitted && !objUnidades.Id_cabecera">La cabecera es requerida.</small>
                </div>
            </div>
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cancelarDialog" />
                <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="guardarUnidad" />
            </template>
        </Dialog>
    </div>
    <ConfirmDialog></ConfirmDialog>
    <Toast />
</template>
<script>
import { FilterMatchMode } from 'primevue/api';
import { mapGetters } from 'vuex'
import Unidades from "../service/Unidades";
import Utilerias from '../utilidades/Utilerias';
export default {
    components: {

    },
    data() {
        return {
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            lstUnidades: [],
            lstJerarquia: [],
            lstEmpleados: [],
            loading: false,
            submitted: false,
            modoEdicion: false,
            showDialog: false,
            objUnidades: {},
            amiba: [
                { label: "Si", value: true },
                { label: "No", value: false },
            ],
        };
    },
    created() {
    },
    mounted() {
        var t = this;
        t.CargaInicial();
    },
    methods: {
        getAmiba(value) {
            var objAmiba = this.amiba.find(amiba => amiba.value === value);
            return objAmiba ? objAmiba.label : '';
        },
        CargaInicial() {
            var t = this;
            var uniSrv = new Unidades();
            t.loading = true;
            uniSrv.getJerarquia(t).then((res) => {
                t.lstUnidades = res;
                t.loading = false;
            })
        },
        cancelarDialog() {
            var t = this;
            t.showDialog = false;
            t.objUnidades = {};
            t.submitted = false;
        },
        agregarUnidad() {
            var t = this;
            t.objUnidades = {};
            t.objUnidades.Amiba = false;
            t.modoEdicion = "Agregar";
            t.showDialog = true;
        },
        editarUnidad(data) {
            var t = this
            t.modoEdicion = "Editar";
            t.objUnidades = { ...data };
            t.showDialog = true;
        },
        guardarUnidad() {
            var t = this;
            t.submitted = true;
            if (!t.objUnidades.Unidad || t.objUnidades.Amiba === null){
                this.$toast.add({
                    severity: "error",
                    summary: "Errar",
                    detail: "Todos los campos son obligadatorios.",
                    life: 3000
                });
                return;
            }

            if (!t.objUnidades.Amiba) {
                t.objUnidades.Id_cabecera = 0;
            } else if (t.objUnidades.Amiba && !t.objUnidades.Id_cabecera) {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "La cabecera es requerida.",
                    life: 3000
                });
                return;
            }

            var unidadNueva = {
                ...t.objUnidades,
                
            }
            
            var uniSrv = new Unidades();

            uniSrv.getAll(t).then(unidades => {
                var unidadesExistentes = unidades.find(unidad => unidad.Unidad.toLowerCase() === unidadNueva.Unidad.toLowerCase());

                if (t.modoEdicion === "Agregar") {
                    if (unidadesExistentes) {
                        t.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "La unidad ya existe.",
                            life: 3000
                        });
                        return;
                    }
                    uniSrv.Add(t, unidadNueva).then(() => {
                        t.CargaInicial()
                        t.$toast.add({
                            severity: "success",
                            summary: "Éxito",
                            detail: "Unidad agregada correctamente",
                            life: 3000
                        })
                    }).catch(() => {
                        t.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error al agregar la unidad",
                            life: 3000
                        });
                    })
                } else if (t.modoEdicion === 'Editar') {
                    if (unidadesExistentes && unidadesExistentes.Id_unidad !== t.objUnidades.Id_unidad) {
                        t.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "La unidad ya existe.",
                            life: 3000
                        });
                        return;
                    }
                    uniSrv.Update(t, unidadNueva).then(() => {
                        t.CargaInicial();
                        t.$toast.add({
                            severity: "success",
                            summary: "Éxito",
                            detail: "Unidad editado correctamente",
                            life: 3000
                        });
                    }).catch(() => {
                        t.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error al actualizar la Unidad",
                            life: 3000
                        });
                    });
                }
                t.submitted = false;
                t.showDialog = false;
                t.objUnidades = {};
                t.CargaInicial();
            }).catch(() => {
                t.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error al verificar la unidad",
                    life: 3000
                });
            });
        },
        forzarUpdate() {
            this.$forceUpdate();
        },
        puedeEditar(){
            let util = new Utilerias();
            return util.isPermiso("EDITOR_CATALOGOS") == true || util.isAdmin() || !util.isCategoria("AUXILIAR DE SOPORTE TECNICO");
        }
    },
    computed: {
        ...mapGetters(['getUsuarioLogueado']),
    }
}
</script>
<style scoped>
.table-header {
    display: flex;
    justify-content: space-between;
    -webkit-box-pack: justify;
}

.title {
    font-weight: 700;
    letter-spacing: 0.3px;
    margin-right: 10px;
    text-transform: uppercase;
}

.data {
    letter-spacing: 0.3px;
    margin-right: 10px;
    letter-spacing: 0.5px;
}
</style>